import { formatAccessType } from "@/utils/format-access-type";
import { formatRole } from "@/utils/format-role";
import { Box } from "@mui/material";
import { TeamsActionsPopover } from "./teams-actions-popover";

export const TeamsColumns = [
  {
    accessorKey: "id",
    header: () => <div style={{ whiteSpace: "nowrap" }}>User ID</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.85rem" }}>{row.original.id ?? "N/A"}</div>
    ),
  },
  {
    accessorKey: "name",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Full Name</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.85rem", whiteSpace: "nowrap" }}>
        {row.original.name ?? "N/A"}
      </div>
    ),
  },
  {
    accessorKey: "emailAddress",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Email</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.85rem", whiteSpace: "nowrap" }}>
        {row.original.emailAddress ?? "N/A"}
      </div>
    ),
  },
  {
    accessorKey: "roles",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Roles</div>,
    cell: ({ row }) => {
      const roles = row.original.roles;

      if (!roles || roles.length === 0) {
        return <div style={{ fontSize: "0.85rem" }}>N/A</div>;
      }

      return (
        <Box sx={{ display: "flex", gap: 0.5, flexWrap: "wrap" }}>
          {roles.map((r) => (
            <Box
              key={r.id}
              sx={{
                px: 1.5,
                py: 0.4,
                borderRadius: "999px",
                backgroundColor: "#eef2ff",
                color: "#3730a3",
                fontSize: "0.75rem",
                fontWeight: 500,
              }}
            >
              {formatRole(r.role)}
            </Box>
          ))}
        </Box>
      );
    },
  },
  {
    accessorKey: "accessTypes",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Access Types</div>,
    cell: ({ row }) => {
      const accessTypes = row.original.accessTypes;

      if (!accessTypes || accessTypes.length === 0) {
        return <div style={{ fontSize: "0.85rem" }}>N/A</div>;
      }

      return (
        <Box sx={{ display: "flex", gap: 0.5, flexWrap: "wrap" }}>
          {accessTypes.map((a) => (
            <Box
              key={a.id}
              sx={{
                px: 1.5,
                py: 0.4,
                borderRadius: "999px",
                backgroundColor: "#ecfdf5",
                color: "#047857",
                fontSize: "0.75rem",
                fontWeight: 500,
              }}
            >
              {formatAccessType(a.type)}
            </Box>
          ))}
        </Box>
      );
    },
  },
  {
    accessorKey: "status",
    header: () => <div>Status</div>,
    cell: ({ row }) => {
      const status = row.original.status;

      const colorMap = {
        "Invite Sent": { bg: "#fff7ed", color: "#c2410c" },
        Accepted: { bg: "#ecfdf5", color: "#047857" },
        Pending: { bg: "#fef3c7", color: "#92400e" },
      };

      const style = colorMap[status] || {
        bg: "#f3f4f6",
        color: "#374151",
      };

      return (
        <Box
          sx={{
            display: "inline-flex",
            alignItems: "center",
            px: 2,
            py: 0.5,
            borderRadius: "999px",
            backgroundColor: style.bg,
            color: style.color,
            fontSize: "0.8rem",
            fontWeight: 500,
            whiteSpace: "nowrap",
          }}
        >
          {status ?? "N/A"}
        </Box>
      );
    },
  },
  {
    accessorKey: "createdBy",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Invited By</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.85rem", whiteSpace: "nowrap" }}>
        {row.original.createdBy ?? "N/A"}
      </div>
    ),
  },
  {
    id: "actions",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Actions</div>,
    cell: ({ row }) => <TeamsActionsPopover admin={row.original} />,
  },
];
